import { Action } from "redux";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";

type Color = string;

export interface HighlightRawData {
  /** The VBID of the book in which the highlight exists */
  isbn: string;
  /** The global ID of the marker */
  markerId: string;
  /** The text of the associated note (if one exists) */
  noteText: string;
  isEmoji: boolean;
  /** The selected text of the highlight */
  selectedText: string;
  /** The unique identifier that has been assigned to the highlight */
  syncId: string;
  /** The GUID of the user */
  userGuid: string;
  /** The CFI for the highlight  ePub only */
  cfi: string;
  /** The background color to be used when rendering the highlight. */
  color: string;
  /** Whether or not this highlight has note text associated with it */
  hasNote: boolean;
  /** A URL to the highlight location with the book */
  location: string;
  authorEmail?: string;
  authorName?: string;
  chapterCfi?: string | null;
  /** start offset of highlight, pdf only */
  chapterOffset: number;
  chapterTitle: string;
  deleted?: null;
  device?: string | "unknown";
  endLabel?: any;
  endOffset?: any;
  endPage?: any;
  endX?: any;
  endY?: any;
  lastModifiedAt: string;
  selectionLength?: number;
  shared?: any;
  startLabel?: any;
  startPage?: any;
  startX?: any;
  startY?: any;
  subscribed: boolean;
  url?: string;
  vstColor: Color;
  vstColorDark: Color;
}

export interface UpdateHighlightData {
  /* The GUID of the marker to which the highlight should be moved */
  markerId?: string;
  /* Note text associated with highlight */
  noteText?: string;
}

export enum HighlightsFilterType {
  None,
  Marker,
  OnlyNotes,
}

export interface HighlightsUnfiltered {
  type: HighlightsFilterType.None;
}

export interface HighlightsMarkerFilter {
  type: HighlightsFilterType.Marker;
  globalId: string;
}

export interface HighlightsOnlyNotesFilter {
  type: HighlightsFilterType.OnlyNotes;
}

export type HighlightsFilter =
  | HighlightsUnfiltered
  | HighlightsMarkerFilter
  | HighlightsOnlyNotesFilter;

// HighlightData contains some computed values
export interface HighlightData extends HighlightRawData {
  authorInitials?: string;
  markerColorName: string;
}

export interface HighlightsState {
  subscribedHighlightsRawData: HighlightRawData[];
  highlightsRawData: HighlightRawData[];
  loadStatus: DetailedLoadStatus;
  highlightsFilter: HighlightsFilter;
}

export const HIGHLIGHTS_SET_FILTER = "highlightsSetFilter";

export interface HighlightsSetFilterAction extends Action {
  type: typeof HIGHLIGHTS_SET_FILTER;
  filter: HighlightsFilter;
}

export type HighlightsAction = HighlightsSetFilterAction;
export type FilteredHighlightData = {
  cfi: string | undefined;
  highlights: HighlightData[];
  title: string;
  uuid: string;
};
export type ChapterHighlights = FilteredHighlightData[];
